//#region src/types.ts
var FILE_DEFAULTS = "defaults.yml";
var FILE_ENVS = "envs-map.yml";
var FILE_DYNAMICS = "config.yml";
//#endregion
export { FILE_DYNAMICS as n, FILE_ENVS as r, FILE_DEFAULTS as t };

//# sourceMappingURL=chunk-types.mjs.map